export function reduceLength(text: string, maxLength: number): string {
    if (text.length > maxLength) {
        const segmentLength = (maxLength / 2) - 2;
        return `${text.substring(0, segmentLength)}...${text.substring(text.length - segmentLength)}`;
    }
    return text;
};